import { Dialog as DialogComponent, dialogClasses } from '@ori-ui/components';
import { paperClasses, styled } from '@ori-ui/mui';
export const Dialog = styled(DialogComponent)(({
  theme
}) => ({
  margin: 'auto',
  maxWidth: '100%',
  zIndex: theme.zIndex.modal + 1,
  [`.${paperClasses.root}`]: {
    width: '100%'
  },
  [`.${dialogClasses.header}`]: {
    padding: theme.spacing(3, 6, 0, 6)
  },
  [`& .${dialogClasses.content}`]: {
    padding: theme.spacing(3, 1, 6, 1)
  },
  [theme.breakpoints.up('sm')]: {
    [`.${paperClasses.root}`]: {
      width: '100%',
      maxWidth: 'min(95vw, 660px)'
    },
    [`& .${dialogClasses.content}`]: {
      padding: theme.spacing(3, 6, 6, 6)
    }
  },
  [theme.breakpoints.up('md')]: {
    [`.${paperClasses.root}`]: {
      maxWidth: '660px'
    }
  }
}));
//# sourceMappingURL=styles.js.map